// extracted by mini-css-extract-plugin
module.exports = {"buttonDownload":"download_buttonDownload__1KGME","downloadIcon":"download_downloadIcon__1BpY5"};